export default function About() {
  return (
    <section id="about" className="bg-paper-100" aria-label="关于本站">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-amber2-600">
              <i className="ri-hand-heart-line" aria-hidden="true"></i> 我们是谁
            </span>
            <h2 className="mt-2 font-serif text-3xl font-black text-ink-950 md:text-4xl">
              做你追剧看现场时的
              <br />
              随身「娱乐档案」
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-ink-600 md:text-base">
              明星爆料是一个聚焦公开娱乐资讯的聚合门户。我们把散落在各处的剧集动态、红毯造型、音乐现场与行业访谈做结构化整理，按形式与话题分类呈现。无论你是想快速了解某部新剧、某支新单曲，还是想系统读懂一个行业话题，都能在这里更快地建立完整认知。
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <div className="rounded-2xl border border-paper-200 bg-white p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gold-100 text-xl text-amber2-600">
                <i className="ri-shield-check-line" aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-serif text-lg font-bold text-ink-900">只做公开内容</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-600">
                信息均整理自公开报道与官方发布，拒绝收录未经证实的私人录音与聊天记录，守住内容底线。
              </p>
            </div>
            <div className="rounded-2xl border border-paper-200 bg-white p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-crimson-100 text-xl text-crimson-500">
                <i className="ri-time-line" aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-serif text-lg font-bold text-ink-900">脉络化梳理</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-600">
                对热点事件做时间线串联与来源标注，让「发生了什么」与「怎么发展的」一目了然。
              </p>
            </div>
            <div className="rounded-2xl border border-paper-200 bg-white p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gold-100 text-xl text-amber2-600">
                <i className="ri-edit-2-line" aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-serif text-lg font-bold text-ink-900">独立长文</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-600">
                编辑部每周产出影视、音乐与时尚领域的深度观察，内容可溯源、观点可讨论。
              </p>
            </div>
            <div className="rounded-2xl border border-paper-200 bg-white p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-crimson-100 text-xl text-crimson-500">
                <i className="ri-refresh-line" aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-serif text-lg font-bold text-ink-900">及时修正</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-600">
                如公开信源出现更正，我们会第一时间同步更新内容，保持信息准确可信。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}